import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, useEffect, useState, useCallback } from "react";
import { BaseCalc } from "../../baseCalc";
import React from "react";
import { StepsSkeleton } from "./stepsSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { selectRequestPlace } from "../../../../redux/selectors/requestPlace";
import { CalcRequestPlace, ProductsFor, ProductsType } from "../../../../types/enums";
import { selectTariffs } from "../../../../redux/selectors/tariffs";
import { Button } from "../../../ui/button/button";
import { sendUpdateForm } from "../../../../requests/loan";
import { setTariffs } from "../../../../redux/slices/tariffs";
import { getStep232Products, getUserProducts } from "../../../../requests/products";
import { selectLifeInsurance, selectCreditRating } from "../../../../redux/selectors/selectedAdditionalServices";
import { InsuranceRejectedModal } from "../../modals/insurances/insuranceRejectedModal";
import { PersonalScoreRejectedModal } from "../../modals/personalSroce.tsx/personalScoreRejectedModal";
import { selectPersonalScore } from "../../../../redux/selectors/personalScore";
import { selectInsurances } from "../../../../redux/selectors/insurances";
import { SelfProhibitionModal } from "../../modals/selfProhibition/selfProhibitionModal";
import { pickInsurance } from "../../../../helpers/pickInsurance";
import { selectSumTerm } from "../../../../redux/selectors/selectSumTerm";
import { setCreditRatingAgree } from "../../../../redux/slices/personalScoreSlice";
import { setInsuranceAgree } from "../../../../redux/slices/lifeInsuranceSlice";
var Step32Layout = React.lazy(function () { return import(/* webpackChunkName: "step32-layout" */ "./step32Layout"); });
var Step232Layout = React.lazy(function () { return import(/* webpackChunkName: "step232-layout" */ "./step232Layout"); });
export var StepsCalculator = function (_a) {
    var context = _a.context, selfProhibitionModal = _a.selfProhibitionModal, tarifDocumentUrl = _a.tarifDocumentUrl;
    var requestPlace = useSelector(selectRequestPlace).requestPlace;
    var tariffs = useSelector(selectTariffs).tariffs;
    var personalScore = useSelector(selectPersonalScore).personalScore;
    var insurance = useSelector(selectInsurances).insurance;
    var lifeInsurance = useSelector(selectLifeInsurance);
    var creditRating = useSelector(selectCreditRating);
    var _b = useState(true), isLoadingTariffs = _b[0], setIsLoadingTariffs = _b[1];
    var _c = useState(false), insuranceRejectModalShow = _c[0], setInsuranceRejectModalShow = _c[1];
    var _d = useState(false), personalScoreRejectModalShow = _d[0], setPersonalScoreRejectModalShow = _d[1];
    var _e = useState(false), selfProhibitionModalShow = _e[0], setSelfProhibitionModalShow = _e[1];
    var sumTerm = useSelector(selectSumTerm).sumTerm;
    var dispatch = useDispatch();
    var saveForm = useCallback(function () {
        var _a;
        if (selfProhibitionModal) {
            setSelfProhibitionModalShow(true);
            return;
        }
        if (lifeInsurance === false && (insurance !== null && pickInsurance((_a = sumTerm === null || sumTerm === void 0 ? void 0 : sumTerm.sum) !== null && _a !== void 0 ? _a : 0) !== null)) {
            setInsuranceRejectModalShow(true);
            return;
        }
        if (creditRating === false && personalScore !== null) {
            setPersonalScoreRejectModalShow(true);
            return;
        }
        sendUpdateForm(context);
    }, [selfProhibitionModal, lifeInsurance, creditRating, insurance, sumTerm, personalScore, context]);
    useEffect(function () {
        setIsLoadingTariffs(true);
        var fetchProducts = requestPlace === CalcRequestPlace.STEP32 ? getUserProducts : getStep232Products;
        fetchProducts(ProductsType.default, ProductsFor.step32Calculator).then(function (response) {
            dispatch(setTariffs(response));
            setIsLoadingTariffs(false);
        });
    }, []);
    if (!tariffs || isLoadingTariffs) {
        return _jsx(StepsSkeleton, {});
    }
    var updateInsurance = function () {
        dispatch(setInsuranceAgree(true));
        sendUpdateForm(context);
    };
    var updatePersonalScore = function () {
        dispatch(setCreditRatingAgree(true));
        sendUpdateForm(context);
    };
    var acceptSelfProhibition = function () {
        setSelfProhibitionModalShow(false);
        sendUpdateForm(context);
        // Открываем госуслуги в новой вкладке
        window.open('https://lk.gosuslugi.ru/', '_blank');
        // Переходим на страницу авторизации в текущей вкладке
        window.location.href = '/auth/?to_documents=1';
    };
    var denySelfProhibition = function () {
        setSelfProhibitionModalShow(false);
        sendUpdateForm(context);
        // Переходим на страницу авторизации в текущей вкладке
        window.location.href = '/auth/?to_documents=1';
    };
    return (_jsx("div", { id: "calculator-block", children: _jsxs(Suspense, { fallback: _jsx(StepsSkeleton, {}), children: [_jsx(BaseCalc, { tarifDocumentUrl: tarifDocumentUrl, Layout: requestPlace === CalcRequestPlace.STEP32 ? Step32Layout : Step232Layout }), _jsx("div", { className: "buttons-next", children: _jsx(Button, { onClick: saveForm, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F" }) }), insuranceRejectModalShow &&
                    _jsx(InsuranceRejectedModal, { onClose: function () { return setInsuranceRejectModalShow(false); }, actionAgree: updateInsurance, actionReject: function () { return sendUpdateForm(context); } }), personalScoreRejectModalShow &&
                    _jsx(PersonalScoreRejectedModal, { onClose: function () { return setPersonalScoreRejectModalShow(false); }, actionAgree: updatePersonalScore, actionReject: function () { return sendUpdateForm(context); } }), selfProhibitionModalShow &&
                    _jsx(SelfProhibitionModal, { onClose: function () { return setSelfProhibitionModalShow(false); }, onAccept: acceptSelfProhibition, onDeny: denySelfProhibition })] }) }));
};
